export default __webpack_public_path__ + "static/uikit-3-9b5573de7d6efc45befcec16311fe380.png";